import { FastOrderInput, FastOrderOutput } from "@/interfaces/fastOrders";
import { BaseService } from "./BaseService";

export class FastOrderService extends BaseService<
  FastOrderInput,
  FastOrderOutput
> {
  constructor() {
    super();
    this.path = "fast-orders";
  }
}
